const API_ROUTE = process.env.VUE_APP_API_ROUTE

// AUTH REQUEST
const LOGIN_REQUEST = API_ROUTE + '/auth/login'
const PASSWORD_EMAIL_REQUEST = API_ROUTE + '/auth/password/email'
const PASSWORD_RESET_REQUEST = API_ROUTE + '/auth/password/reset'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'
const GENERATE_TEMPORAL_MODULE_TOKEN_REQUEST = API_ROUTE + '/auth/generate_temporal_module_token'
const MODULES_REQUEST = API_ROUTE + '/get_all_modules_user'

export default {
    LOGIN_REQUEST,
    PASSWORD_EMAIL_REQUEST,
    PASSWORD_RESET_REQUEST,
    LOGOUT_REQUEST,
    GENERATE_TEMPORAL_MODULE_TOKEN_REQUEST,
    MODULES_REQUEST,
}
